import React from 'react';
import { Linkedin, Instagram, Mail } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const links = {
    explore: [{
      name: 'Framework',
      href: '#framework'
    }, {
      name: 'Research',
      href: '#research'
    }, {
      name: 'Programs',
      href: '#programs'
    }, {
      name: 'Partnerships',
      href: '#partnerships'
    }, {
      name: 'Summit',
      href: '#summit'
    }],
    initiatives: [{
      name: 'Ontario Research',
      href: '#research'
    }, {
      name: 'Founder Programs',
      href: '#programs'
    }, {
      name: 'Strategic Roundtables',
      href: '#programs'
    }, {
      name: 'Ecosystem Partners',
      href: '#partnerships'
    }]
  };
  return <footer className="bg-charcoal-navy text-white/60 pt-20 pb-10 relative overflow-hidden" data-id="element-31">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-golden-yellow/40 to-transparent" data-id="element-32"></div>
      <div className="absolute top-0 right-0 w-[40%] h-[60%] bg-azure/5 blur-[140px]" data-id="element-33"></div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-34">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-35">
          <div className="md:col-span-5" data-id="element-36">
            <h3 className="font-display text-3xl text-white mb-2 tracking-tight" data-id="element-37">
              Lead<em className="italic font-light text-golden-yellow" data-id="element-38">HER</em>
              ship Equity
            </h3>
            <p className="text-sm font-display italic text-white/50 mb-6" data-id="element-39">
              Changing Optics. Creating Outcomes.
            </p>
            <p className="text-sm max-w-md leading-relaxed mb-8 font-light" data-id="element-40">
              A social enterprise advancing women founders and leaders through
              measurable support, strategic infrastructure, ecosystem
              intelligence, and economic access.
            </p>
            <div className="flex gap-3" data-id="element-41">
              {[{
              icon: <Linkedin className="w-4 h-4" data-id="element-42" />,
              label: 'LinkedIn'
            }, {
              icon: <Instagram className="w-4 h-4" data-id="element-43" />,
              label: 'Instagram'
            }, {
              icon: <Mail className="w-4 h-4" data-id="element-44" />,
              label: 'Email'
            }].map(social => <a key={social.label} href="#" aria-label={social.label} className="w-9 h-9 border border-white/15 flex items-center justify-center hover:border-golden-yellow hover:text-golden-yellow transition-colors" data-id="element-45">
                  {social.icon}
                </a>)}
            </div>
          </div>

          <div className="md:col-span-3" data-id="element-46">
            <h4 className="text-[11px] font-semibold tracking-[0.3em] uppercase text-golden-yellow mb-6" data-id="element-47">
              Explore
            </h4>
            <ul className="space-y-3" data-id="element-48">
              {links.explore.map(link => <li key={link.name} data-id="element-49">
                  <a href={link.href} className="text-sm hover:text-golden-yellow transition-colors font-light" data-id="element-50">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>

          <div className="md:col-span-4" data-id="element-51">
            <h4 className="text-[11px] font-semibold tracking-[0.3em] uppercase text-golden-yellow mb-6" data-id="element-52">
              Initiatives
            </h4>
            <ul className="space-y-3" data-id="element-53">
              {links.initiatives.map(link => <li key={link.name} data-id="element-54">
                  <a href={link.href} className="text-sm hover:text-golden-yellow transition-colors font-light" data-id="element-55">
                    {link.name}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/40 font-light" data-id="element-56">
          <p data-id="element-57">&copy; {currentYear} LeadHERship Equity. All rights reserved.</p>
          <div className="flex gap-6" data-id="element-58">
            <a href="#" className="hover:text-golden-yellow transition-colors" data-id="element-59">
              Privacy
            </a>
            <a href="#" className="hover:text-golden-yellow transition-colors" data-id="element-60">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>;
}